<template>
  <div class="row">
    <div class="col-12">
      Navigation Preview
    </div>
    <div class="col-12">
      <div class="nav-preview">
        <div class="nav-preview__main">
          <div class="nav-preview__aside">
            <div v-for="(childItem, index) in previewSelectedChildItems" :key="index" class="menu-item">
              <fa v-if="childItem.icon[0] !== '' && childItem.icon[1] !== ''" class="mx-2" :icon="[childItem.icon[0], childItem.icon[1]]" />
              <span v-html="childItem.label[lang]"></span>
            </div>
          </div>
        </div>
        <div class="nav-preview__menu">
          <div v-for="baseItem in navItemsNested" :key="baseItem.id" class="menu-item" :class="selectedPreviewItemId == baseItem.id ? 'selected' : ''" @click="setSelectedPreviewItemId(baseItem.id)">
            <div v-html="baseItem.label[lang]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {

  name: 'navigation-preview',

  props: {
    navItemsNested: Array,
    lang: String
  },

  data() {
    return {
      selectedPreviewItemId: null
    }
  },

  computed: {
    previewSelectedChildItems() {
      // find parent item
      let parentItem = _.find(this.navItemsNested, item => {
        return item.id == this.selectedPreviewItemId;
      });

      return parentItem ? parentItem.children : null;
    }
  },

  methods: {
    setSelectedPreviewItemId(id) {
      this.selectedPreviewItemId = id;
    }
  }
}
</script>
<style lang="scss" scoped>

.nav-preview {
  background: #999;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.8vw;
  height: 56vw;
  overflow: hidden;
  width: 100%;

  @media (min-width: 700px) {
    font-size: 11px;
    height: calc(1080px / 3);
    width: calc(1920px / 3);
  }

  @media (min-width: 1400px) {
    font-size: 14px;
    height: calc(1080px / 2);
    width: calc(1920px / 2);
  }

  &__main {
    background: #999;
    height: 91%;
    width: 100%;
  }

  &__aside {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    font-size: .9em;
    justify-content: flex-end;
    background: #666;
    height: 100%;
    padding: 20px 0;
    margin: 0 0 0 auto;
    width: 21%;

    .menu-item {
      color: #fff;
      padding: 0 0 0 15px;
      margin: 5px 0;
      text-align: left;
      width: 100%;
    }
  }

  &__menu {
    align-items: center;
    background: #333;
    display: flex;
    height: 9%;
    justify-content: center;
    width: 100%;

    .menu-item {
      border-bottom: 1px solid transparent;
      color: #fff;
      cursor: pointer;
      margin: 0 10px;
      user-select: none;

      &.selected {
        border-bottom: 1px solid #fff;
      }
    }
  }
}
</style>